import Select from 'react-select';
import {useState, useEffect} from "react";


const SearchableDropdown = (props) => {

    const [isFocused, setIsFocused] = useState(false);
    const [selectedValue, setSelectedValue] = useState(props.value);

    const options = props.dataset.data.map(item => ({
        value: item[props.dataset.value],
        label: props?.occupancyCheck
            ? !item?.max_occupancy || (item?.number_residents && item?.number_residents >= item?.max_occupancy)
                ? item[props.dataset.label] + " (Room Full)"
                : item?.devices && item?.devices?.length > 0
                    ? item[props.dataset.label] + " (NO DEVICES)"
                    : item[props.dataset.label]
            : item[props.dataset.label],
        isDisabled: props?.occupancyCheck
            ? !item?.max_occupancy || (item?.number_residents && item?.number_residents >= item?.max_occupancy)
            : false
    }));

    useEffect(() => {
        if (props?.value === '' || props?.value === 0) {
            setSelectedValue(null);
        }else{
            for (let i=0; i < options.length; i++){
                if (options[i].value === props?.value){
                    setSelectedValue(options[i]);
                    break;
                }
            }
        }
    }, [props?.value, props.dataset.data]);

    // Call formCheck when selectedValue changes
    useEffect(() => {
        if (props.formCheck) {
            props.formCheck();
        }
    }, [selectedValue]);

    const customStyles = {
        control: (base, state) => ({...base, minHeight: '38px', height: props?.height ? props.height : "unset",
            borderColor: props?.required ? state.hasValue ? 'var(--color-success)' : 'var(--color-danger)' : 'var(--color-border-medium)', borderWidth: '1px',
            backgroundColor: 'var(--color-bg-surface)',
            transition: 'background-color var(--transition-fast), border-color var(--transition-fast)',
            '&:hover': {
                borderColor: props?.required ? state.hasValue ? 'var(--color-success)' : 'var(--color-danger)' : 'var(--color-border-medium)'
            },
            '&:focus-within': {
                borderColor: props?.required ? state.hasValue ? 'var(--color-success)' : 'var(--color-danger)' : 'var(--color-border-medium)',
            }
        }),
        option: (base, state) => ({...base,
            backgroundColor: state.isSelected ? 'var(--color-primary)' : state.isFocused ? 'var(--color-bg-tertiary)' : 'var(--color-bg-surface)',
            color: state.isDisabled ? 'var(--color-text-muted)' : state.isSelected ? 'var(--color-text-inverse)' : 'var(--color-text-primary)',
            cursor: state.isDisabled ? 'not-allowed' : 'default',
            '&:hover': {
                backgroundColor: state.isDisabled ? 'var(--color-bg-surface)' : state.isSelected ? 'var(--color-primary)' : 'var(--color-bg-tertiary)'
            }
        }),
        menu: (base) => ({...base, zIndex: 9999, backgroundColor: 'var(--color-bg-surface)', borderColor: 'var(--color-border)'}),
        singleValue: (base) => ({...base, color: 'var(--color-text-primary)'}),
        placeholder: (base) => ({...base, color: 'transparent'}),
        input: (base) => ({...base, color: 'var(--color-text-primary)'}),
        menuList: (base) => ({...base, backgroundColor: 'var(--color-bg-surface)'})
    };

    return (
        <>
            <div className={`my-1 position-relative ${props?.divClass ? props?.divClass : ""}`}
                 id={props.id+"-div"}>
                <div style={{
                    position: 'absolute',
                    top: (isFocused || selectedValue) ? '-10px' : '8px',
                    left: '12px',
                    backgroundColor: 'var(--color-bg-surface)',
                    padding: '0 5px',
                    transition: 'all var(--transition-fast)',
                    zIndex: 1,
                    fontSize: (isFocused || selectedValue) ? 'var(--font-size-sm)' : 'var(--font-size-base)',
                    color: props?.required ? props.value ? 'var(--color-text-muted)' : 'var(--color-danger)' : 'var(--color-border-medium)'
                }}>
                    {props.label_name}
                </div>
                <Select
                    id={props.id}
                    options={options}
                    styles={customStyles}
                    placeholder=" "
                    isClearable={props?.clearable}
                    isSearchable
                    className="basic-single"
                    classNamePrefix="select"
                    required={props?.required}
                    aria-required="true"
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    onChange={(value) => {
                        props.onChange(value?.value)
                        setSelectedValue(value)
                    }}
                    value={selectedValue}
                />
            </div>
        </>
    );
};

export default SearchableDropdown;
